import { search, get } from '../helpers/api';

export const AUTH_SERVICE_URI = '/portal';
export const AUTH_BASE_URI = '/api/v1/taxonomies';
const institutionsCache = new Map();

export const getTaxonomyData = async (data, taxonomy) =>
  search(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/${taxonomy}`, data);

export const getDocTypes = async (data) => getTaxonomyData(data, 'doc-types');

export const getUserTypes = async (data) => getTaxonomyData(data, 'user-types');

export const getPosesByRole = async () => {
  return search(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/poses`, {
    criterias: { byrole: '', deleted: false },
  });
};

export const getSubdivisions = async (data) =>
  search(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/institution-subdivisions`, data);

export const getInstitutions = async (data) => {
  const cacheKey = JSON.stringify(data);
  if (institutionsCache.has(cacheKey)) {
    return institutionsCache.get(cacheKey);
  }
  const promise = getTaxonomyData(data, 'institutions')
    .then((result) => {
      institutionsCache.set(cacheKey, Promise.resolve(result));
      return result;
    })
    .catch((error) => {
      institutionsCache.delete(cacheKey);
      throw error;
    });
  institutionsCache.set(cacheKey, promise);
  return promise;
};

export const getCountries = async (data) => getTaxonomyData(data, 'countries');

export const getInstitutionById = async (id) =>
  get(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/institution/${id}`);

export const getUserTypeIdsByInstitutionId = async (id) =>
  get(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/user-types/institution/${id}`);
